import { Box, Typography } from "@mui/material";
import { DayContent, Status, WeekDay, WeekWrapper } from "./styles";
import { formatMonthlyTimeKeepingData } from "./utils";
import moment from "moment";

const listDays = [
  "Thứ 2",
  "Thứ 3",
  "Thứ 4",
  "Thứ 5",
  "Thứ 6",
  "Thứ 7",
  "Chủ nhật",
];

interface IProps {
  timeSheetData: {
    [key: string]: string;
  };
}

export const TimeSheet = ({ timeSheetData }: IProps) => {
  const weeks = formatMonthlyTimeKeepingData(timeSheetData);

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "auto",
      })}
    >
      <Box display="flex" justifyContent="space-evenly" width="100%">
        {listDays.map((day) => (
          <WeekDay key={day} alignItems={"center"}>
            {day}
          </WeekDay>
        ))}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        width="100%"
        sx={(theme) => ({
          // border: `1px solid ${theme.palette.stroke.strokeDefault}`,
        })}
      >
        {(weeks ?? []).map((week, weekIndex) => (
          <WeekWrapper key={weekIndex}>
            {week.map((dayInfo, dayIndex) => (
              <DayContent key={dayIndex} className="content">
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  justifyContent="center"
                  sx={(theme) => ({
                    flexWrap: "wrap",
                  })}
                >
                  <Typography
                    variant="body2"
                    sx={(theme) => ({
                      fontWeight: theme.typography.fw_regular_400,
                      color:
                        dayInfo.status === "outside" ||
                        moment(dayInfo.day, "DD/MM/YYYY").day() === 6 ||
                        moment(dayInfo.day, "DD/MM/YYYY").day() === 0
                          ? theme.palette.text.textSecondary
                          : theme.palette.text.textPrimary,
                    })}
                  >
                    {dayInfo.day.split("/")[0]}
                  </Typography>
                  {dayInfo.status !== "outside" && dayInfo.status && (
                    <Status dayStatus={dayInfo.status}>{dayInfo.status}</Status>
                  )}
                </Box>
              </DayContent>
            ))}
          </WeekWrapper>
        ))}
      </Box>
    </Box>
  );
};
